export function buildTestDmpExistenceCommand(reqId: string, insType: 'N' | 'D' | 'T', insValue: string) {
  return `
    <?xml version="1.0" encoding="utf-8"?>
    <request action="testDmpExistence" id="${reqId}">
      <patient>
        <ins root="${insType}" extension="${insValue}"/>
      </patient>
    </request>
  `
}

export function buildOpenDmpCommand(reqId: string, insType: 'N' | 'D' | 'T', insValue: string) {
  return `
    <?xml version="1.0" encoding="utf-8"?>
    <request action="openDmp" id="${reqId}">
      <patient>
        <ins root="${insType}" extension="${insValue}"/>
      </patient>
    </request>
  `
}

export interface MssPatientInfo {
  name: string
  given: string
  ins: string
}

export function buildSetMssPatientInfosCommand(reqId: string, patients: MssPatientInfo[]) {
  const patientsXml = patients
    .map(
      (p) => `
        <patient>
          <name>${p.name}</name>
          <given>${p.given}</given>
          <ins>${p.ins}</ins>
        </patient>`,
    )
    .join('')

  return `
    <?xml version="1.0" encoding="utf-8"?>
    <request action="setMssPatientInfos" id="${reqId}">
      <patients>${patientsXml}
      </patients>
    </request>
  `
}
